import { formatMoney as accountingFormatMoney } from 'accounting-js';
/**
 * Formats a given `Number` as a currency string, based on the provided `CurrencyFormatOptions`.
 * Wrapper for accounting-js `formatMoney` (http://openexchangerates.github.io/accounting.js/#methods).
 *
 * @hidden
 * @param value The `Number` value to be formatted.
 * @param options The currency format options to be used.
 * @returns The formatted currency string.
 */
export const formatCurrency = (value, options) => {
    const { nonNumberPlaceholder, symbol, format, decimalPrecision, thousandsSeparator, decimalSeparator } = options;
    if (value == null) {
        return nonNumberPlaceholder;
    }
    else if (isNaN(value)) {
        throw new Error(`formatCurrency - received a non numerically assigned value: ${value}`);
    }
    const currencySettings = {
        symbol: symbol,
        format: format,
        precision: decimalPrecision,
        thousand: thousandsSeparator,
        decimal: decimalSeparator
    };
    return accountingFormatMoney(value, currencySettings);
};
//# sourceMappingURL=format-currency.js.map